module.exports = __webpack_public_path__ + "img/mb-signout.9b10a065.svg";